import PropTypes from 'prop-types';
import React from 'react';

import Icon from '@component/icon';

export default class PlanSelector extends React.Component {
  static propTypes = {
    checked: PropTypes.bool,
    classNames: PropTypes.array,
    copy: PropTypes.string,
    defaultValue: PropTypes.string,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    price: PropTypes.number.isRequired,
    subCopy: PropTypes.string,
    currencyCode: PropTypes.string.isRequired,
    currencySign: PropTypes.string.isRequired,
  };

  static defaultProps = {
    classNames: [],
  };

  /**
   * Binds all private methods
   * @param  {Object} props Component props
   */
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.planSelectorNode.click();
  }

  render() {
    const className = ['planselector'];
    const {
      label,
      name,
      defaultValue,
      onChange,
      checked,
      price,
      copy,
      disabled,
      currencyCode,
      currencySign,
    } = this.props;

    className.push(`planselector--${defaultValue}`);

    if (this.props.classNames.length) {
      className.push(...this.props.classNames);
    }

    if (checked) {
      className.push('planselector--checked');
    } else {
      className.push('planselector--unchecked');
    }

    if (disabled) {
      className.push('planselector--disabled');
    }

    let { subCopy } = this.props;
    if (subCopy) {
      subCopy = (
        <span key="plan_selector" className="planselector__subcopy">
          {subCopy}
        </span>
      );
    }

    return (
      <div
        className={className.join(' ')}
        onClick={!disabled ? this.handleClick : null}
      >
        <span className="planselector__radio">
          {checked ? <Icon type="Valid" /> : null}
        </span>
        <div className="planselector__price">
          {currencySign}
          {price}
          {currencySign === '$' && <sup>{currencyCode}</sup>}
          {subCopy}
        </div>
        <div className="planselector__label">{label}</div>
        <div className="planselector__copy">{copy}</div>
        <input
          ref={(node) => (this.planSelectorNode = node)}
          className="planselector__field"
          id={name}
          name={name}
          onChange={onChange}
          checked={checked}
          defaultValue={defaultValue}
          label={label}
          type="radio"
        />
      </div>
    );
  }
}
